import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IScoreConversionTable } from "./types";

/**
 * Score Conversion Table 상세 조회 API 함수
 * @param id Score Conversion Table ID
 * @returns API 응답 객체
 */
export const apiGetScoreConversionTable = async (id: string) => {
  const response = await apiGet<IScoreConversionTable>(
    `/score_conversion_tables/${id}`
  );
  return response.data;
};

/**
 * Score Conversion Table 상세 조회 Query Hook
 * @param id Score Conversion Table ID
 */
export const useScoreConversionTableQuery = (id: string) => {
  return useQuery({
    queryKey: QueryKeys.scoreConversionTable.detail(id),
    queryFn: () => apiGetScoreConversionTable(id),
    enabled: !!id,
  });
}; 